<template>
  <div>

    <div class="has-text-centered mb-6" v-if="init.name || init.subname">
      <h1 v-if="init.name" class="title is-3">{{init.name}}</h1>
      <h2 v-if="init.subname" class="subtitle is-5">{{init.subname}}</h2>
    </div>

    <div class="tabs is-centered is-boxed">
      <ul>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
            <span>Informazioni</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">
          
        <form class="columns is-multiline" @submit.prevent="call._id ? updateCall() : saveCall()">
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Data</label>
              <div class="control">
                <input class="input" type="date" placeholder="Data" v-model="call.date" required />
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Ora</label>
              <div class="control">
                <input class="input" type="time" placeholder="Data" v-model="call.time" />
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label" for="lostCall">Chiamata persa</label>
              <div class="control">
                <label class="checkbox">
                  <input type="checkbox" v-model="call.lost" id="lostCall">
                </label>
              </div>
            </div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Tipologia"
              v-model="call.type"
              :options="$store.state.operation_types.map(({ name }) => name)"
            />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Priorità"
              v-model="call.priority"
              :options="['Bassa', 'Media', 'Alta']"
            >
              <template #option="props">
                <div class="is-flex is-justify-content-space-between" >
                  <div>{{ props.option }}</div>
                  <div :style="{ width: '50px', background: calcBg(props.option)}"></div>
                </div>
              </template>
              <template #singleLabel="props">
                <div class="is-flex is-justify-content-space-between" >
                  <div>{{ props.option }}</div>
                  <div :style="{ width: '50px', background: calcBg(props.option)}"></div>
                </div>
              </template>
            </InputSelect>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="call.lost">
            <InputText name="Telefono" v-model="call.lost_number">
              <button class="button is-primary" :class="{'is-loading': searchingTelephone}" @click="searchTelephone" type="button">
                <font-awesome-icon icon="magnifying-glass" class="m-0" />
              </button>
            </InputText>
          </div>

          <div class="column is-12 py-0"></div>

          <div v-if="!call?._id" class="column is-12-mobile is-12-tablet is-6-desktop">
            <ImplantSearchSelect
              v-model="implantSearch"
              :disabled="waitRecord || fastInsert"
              @select="selectImplantSearch"
              @remove="clearImplantSearch"
            />
          </div>

          <div class="column is-12 py-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Proprietario"
              v-model="call.client"
              :options="clients"
              :loading="waitClients"
              :disabled="disableClient || waitRecord || fastInsert"
              id="_id"
              track-by="_id"
              :custom-label="$clientName"
              @select="changeClient"
            >
              <button v-show="!fastInsert" class="button is-success" type="button" @click="fastInsert = true" title="Inserimento rapido"><font-awesome-icon icon="plus" class="m-0" /></button>
              <button v-show="fastInsert" class="button is-danger" type="button" @click="fastInsert = false" title="Chiudi inserimento rapido"><font-awesome-icon icon="minus" class="m-0" /></button>
              <button v-show="!fastInsert" class="button is-info" type="button" @click="openFastContact = true" title="Aggiungi contatto" :disabled="!call.client"><font-awesome-icon icon="phone" class="m-0" /></button>
              <a class="button is-warning" :href="call.client ? '/clienti/'+call.client._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
            </InputSelect>

            <ClientInfo :client="call.client" />
          </div>

          <div class="column is-12 py-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Occupante"
              v-model="call.occupant"
              :options="clients"
              :loading="waitClients"
              :disabled="disableOccupant || waitRecord || fastInsert"
              id="_id"
              track-by="_id"
              :custom-label="$clientName"
              @select="changeOccupant"
            >
              <button v-show="!fastInsert" class="button is-success" type="button" @click="fastInsert = true" title="Inserimento rapido"><font-awesome-icon icon="plus" class="m-0" /></button>
              <button v-show="fastInsert" class="button is-danger" type="button" @click="fastInsert = false" title="Chiudi inserimento rapido"><font-awesome-icon icon="minus" class="m-0" /></button>
              <button v-show="!fastInsert" class="button is-info" type="button" @click="openFastContact = true" title="Aggiungi contatto" :disabled="!call.occupant"><font-awesome-icon icon="phone" class="m-0" /></button>
              <a class="button is-warning" :href="call.occupant ? '/clienti/'+call.occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
            </InputSelect>

            <ClientInfo :client="call.occupant" />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Luogo"
              v-model="call.place"
              :options="places"
              :loading="waitPlaces"
              :disabled="waitRecord || (!call.client && !call.occupant) || fastInsert"
              id="_id"
              track-by="_id"
              :custom-label="$placeName"
              @select="changePlace"
            >
              <a class="button is-warning" :href="call.place ? '/luoghi/'+call.place._id : 'javascript:void(0)'"><font-awesome-icon icon="building" class="m-0" /></a>
            </InputSelect>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Impianto"
              v-model="call.implant"
              :options="implants"
              :loading="waitImplants"
              :disabled="waitRecord || !call.place || fastInsert"
              id="_id"
              track-by="_id"
              :custom-label="$implantName"
              @select="changeImplant"
            >
              <a class="button is-warning" :href="call.implant ? '/impianti/'+call.implant._id : 'javascript:void(0)'"><font-awesome-icon icon="temperature-arrow-up" class="m-0" /></a>
            </InputSelect>
          </div>

          <div class="column is-12 py-0" v-if="fastInsert"><hr></div>
          <div class="column is-12" v-if="fastInsert">
            <h3 class="title is-4">Cliente</h3>
          </div>
          
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Nome occupante" v-model="call.tempClient.name" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Cognome occupante" v-model="call.tempClient.surname" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Ragione sociale occupante" v-model="call.tempClient.business_name" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Nome proprietario" v-model="call.tempClient.name_owner" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Cognome proprietario" v-model="call.tempClient.surname_owner" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Ragione sociale proprietario" v-model="call.tempClient.business_name_owner" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputSelect
              name="Installatore"
              v-model="call.tempClient.installer"
              :options="installers"
              :loading="waitInstallers"
              :disabled="waitInstallers"
              id="_id"
              track-by="_id"
              :custom-label="$clientName"
            />
          </div>
          <div class="column is-12 py-0" v-if="fastInsert"></div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Città residenza occupante" v-model="call.tempClient.city_residence" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-2-desktop" v-if="fastInsert">
            <InputText name="Provincia residenza occupante" v-model="call.tempClient.province_residence" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Indirizzo residenza occupante" v-model="call.tempClient.address_residence" />
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop" v-if="fastInsert">
            <InputText name="Piano residenza occupante" v-model="call.tempClient.floor_residence" />
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop" v-if="fastInsert">
            <InputText name="Interno residenza occupante" v-model="call.tempClient.interior_residence" />
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="CAP residenza occupante" v-model="call.tempClient.zip_residence" />
          </div>

          <div class="column is-12"></div>

          <div v-for="(contact, index) in call.tempClient.contacts" :key="index" class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <div class="box">
              <div class="columns is-multiline mb-0" style="margin-left: -0.75rem; margin-right: -0.75rem;">
                <div class="column is-6-tablet">
                  <InputText name="Nome" v-model="contact.name" />
                </div>
                <div class="column is-6-tablet">
                  <InputText name="Telefono" v-model="contact.telephone" type="tel" required>
                    <a class="button is-warning" :href="contact.telephone ? 'tel:'+contact.telephone : ''"><font-awesome-icon icon="phone" class="m-0" /></a>
                  </InputText>
                </div>
              </div>
              <div class="has-text-right">
                <button class="button is-small is-danger" type="button" @click="call.tempClient.contacts.length > 1 ? call.tempClient.contacts.splice(index, 1) : null">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <div class="is-flex is-justify-content-center is-align-items-center" style="height: 100%">
              <button class="button is-info" type="button" @click="call.tempClient.contacts.push({})"><font-awesome-icon icon="plus" />Aggiungi contatto</button>
            </div>
          </div>

          <div class="column is-12 py-0" v-if="fastInsert"><hr></div>
          <div class="column is-12" v-if="fastInsert">
            <h3 class="title is-4">Luogo</h3>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Città impianto" v-model="call.tempClient.city" required>
              <button class="button is-primary" type="button" @click="call.tempClient.city = call.tempClient.city_residence" title="Copia città residenza"><font-awesome-icon icon="copy" class="m-0" /></button>
            </InputText>
          </div>
          <div class="column is-12-mobile is-6-tablet is-2-desktop" v-if="fastInsert">
            <InputText name="Provincia impianto" v-model="call.tempClient.province">
              <button class="button is-primary" type="button" @click="call.tempClient.province = call.tempClient.province_residence" title="Copia provincia residenza"><font-awesome-icon icon="copy" class="m-0" /></button>
            </InputText>
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="Indirizzo impianto" v-model="call.tempClient.address" required>
              <button class="button is-primary" type="button" @click="call.tempClient.address = call.tempClient.address_residence" title="Copia indirizzo residenza"><font-awesome-icon icon="copy" class="m-0" /></button>
            </InputText>
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop" v-if="fastInsert">
            <InputText name="Piano impianto" v-model="call.tempClient.floor">
              <button class="button is-primary" type="button" @click="call.tempClient.floor = call.tempClient.floor_residence" title="Copia piano residenza"><font-awesome-icon icon="copy" class="m-0" /></button>
            </InputText>
          </div>
          <div class="column is-6-mobile is-3-tablet is-2-desktop" v-if="fastInsert">
            <InputText name="Interno impianto" v-model="call.tempClient.interior">
              <button class="button is-primary" type="button" @click="call.tempClient.interior = call.tempClient.interior_residence" title="Copia interno residenza"><font-awesome-icon icon="copy" class="m-0" /></button>
            </InputText>
          </div>
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <InputText name="CAP impianto" v-model="call.tempClient.zip">
              <button class="button is-primary" type="button" @click="call.tempClient.zip = call.tempClient.zip_residence" title="Copia CAP residenza"><font-awesome-icon icon="copy" class="m-0" /></button>
            </InputText>
          </div>

          <div class="column is-12 py-0" v-if="fastInsert"><hr></div>
          <div class="column is-12" v-if="fastInsert">
            <h3 class="title is-4">Impianto</h3>
          </div>
          
          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <FormBrand v-model="call.tempClient.brand"/>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="fastInsert">
            <FormModel v-model="call.tempClient.model"/>
          </div>
          <div class="column is-12 py-0" v-if="fastInsert"><hr></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="similarCalls?.length && call.place">
            <div class="field">
              <label class="label">Trovate chiamate per lo stesso luogo (30gg)</label>
              <div class="control">
                <div class="box" v-for="(similarCall, index) in similarCalls" :key="index" style="position: relative;">
                  <div class="is-flex is-justify-content-space-between">
                    <div style="width: 100%;">
                      <div class="is-flex is-justify-content-space-between">
                        <div>
                          <router-link :to="'/chiamate/' + similarCall._id" target="_blank">
                            <h3 class="title is-5">{{similarCall.type}}</h3>
                          </router-link>
                        </div>
                        <div :class="'tag is-info ' + (similarCall?.operator?.color ? similarCall?.operator?.color + '-card' : '')">
                          {{$fullname(similarCall.operator)}}
                        </div>
                      </div>
                      <div>
                        <div>{{new Date(similarCall.date).toDisplay()}}</div>
                        <div>
                          <small class="has-text-grey is-abbr-like">{{similarCall.time}}</small>
                        </div>
                      </div>
                      <div>
                        <ClientHeading :client="similarCall.occupant" />
                        <ClientHeading :client="similarCall.client" :owner="true" />
                      </div>
                    </div>
                  </div>
                  <router-link :to="'/chiamate/' + similarCall._id" class="button is-warning is-small" type="button" title="Modifica" target="_blank" style="position: absolute;right: 20px;bottom: 20px;">
                    <span class="icon"><font-awesome-icon icon="pen" /></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-12 py-0" v-if="similarCalls?.length && call.place"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Collaboratore"
              v-model="call.operator"
              :options="$store.getters.operators"
              id="_id"
              track-by="_id"
              :custom-label="$fullname"
            />
          </div>

          <div class="column is-12 py-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputTextarea name="Motivo chiamata" v-model="call.notes" required />
          </div>

          <div class="column is-12 py-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="card mb-3" v-for="(archived_note, index) in call.archived_notes?.toReversed()" :key="index">
              <div class="card-content">
                <div class="content">
                  <div><span class="is-size-6 has-text-weight-bold">Data: </span>{{ (new Date(archived_note.date)).toDisplay() }}</div>
                  <InputTextarea name="Motivo intervento" :modelValue="archived_note.notes_office" disabled />
                  <InputTextarea name="Note tecnico" :modelValue="archived_note.notes" disabled />
                </div>
              </div>
            </div>
          </div>

          <div class="column is-full">
            <div class="field is-grouped is-grouped-centered buttons">
              <button @click="goBack()" class="button is-light" type="button"><font-awesome-icon icon="times" />Chiudi</button>
              <button class="button is-primary" :class="[{'is-loading': disabledSave}]" type='submit' :disabled="disabledSave"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>
        </form>

      </div>
    </transition>

    <Modal :title="'Aggiungi contatto'" :openModal="openFastContact" @close="openFastContact = false" @success="saveFastContact()" :loading="disabledFastContactSave">
      <div>
        <InputText name="Nome" v-model="newContact.name" />
        <InputText name="Telefono" v-model="newContact.telephone" type="tel" />
      </div>
    </Modal>

    <Modal :title="'Clienti trovati'" :openModal="openClientList" @close="openClientList = false" :noAction="true">
      <div v-if="openClientList">
        <div class="box" v-for="(client, index) in clients" :key="index">
          <div class="is-flex is-justify-content-space-between">
            <div>
              <b><ClientHeading :client="client" /></b>
            </div>
            <div class="buttons">
              <button class="button is-primary" type="button" @click="addClientFromSearch(client)">Cliente</button>
              <button class="button is-primary" type="button" @click="addOccupantFromSearch(client)">Occupante</button>
            </div>
          </div>
          <div>
            <div>{{client.city}}</div>
            <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(client)">{{$fulladdress(client)}}</small></div>
          </div>
          <div class="is-flex is-align-items-center mt-2">
            <div v-for="(contact, index) in client.contacts" :key="index">
              <div v-if="contact.telephone" class="is-flex is-align-items-center" :class="{'ml-2': index}">
                <div class="mr-2" style="font-size: 0.9rem;">
                  <div>{{contact.name}}</div>
                  <div>{{contact.telephone}}</div>
                </div>
                <a class="button is-warning is-small" :href="contact.telephone ? 'tel:'+contact.telephone : ''">
                  <font-awesome-icon icon="phone" class="m-0" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

  </div>
</template>

<script>
import utils from '../utils'
import ImplantSearchSelect from '../components/ImplantSearchSelect.vue'

export default {
  components: {
    ImplantSearchSelect
  },
  data() {
    return {
      call: {
        date: new Date().toDateInputValue(),
        time: new Date().toDateTimeInput(),
        tempClient: {
          contacts: [{}]
        }
      },
      clients: [],
      places: [],
      implants: [],

      init: {
        name: false,
        subname: false
      },

      tabActive: 'info',

      waitRecord: true,
      waitClients: true,
      waitInstallers: true,
      waitPlaces: false,
      waitImplants: false,

      isGeocoding: false,
      disabledSave: false,

      fastInsert: false,

      openFastContact: false,
      newContact: {
        name: '',
        telephone: ''
      },
      disabledFastContactSave: false,

      disableOccupant: false,
      disableClient: false,

      similarCalls : [],

      openClientList: false,
      searchingTelephone: false,
      clients: [],
      installers: [],

      implantSearch: null
    }
  },

  methods: {
    normalizeProvinceCode(value) {
      return (value || '').toString().replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2)
    },

    normalizeTempClientProvinces() {
      if (!this.call?.tempClient || typeof this.call.tempClient !== 'object') {
        return
      }

      this.call.tempClient.province = this.normalizeProvinceCode(this.call.tempClient.province)
      this.call.tempClient.province_residence = this.normalizeProvinceCode(this.call.tempClient.province_residence)
    },

    saveCall() {
      if (!this.checkRequired()) return

      const self = this
      this.disabledSave = true

      if (this.fastInsert) {
        this.normalizeTempClientProvinces()
        this.call.client = null
        this.call.occupant = null
        this.call.place = null
        this.call.implant = null
      } else {
        this.call.tempClient = {}
      }

      this.$http.post('/call', this.call)
      .then(function (response) {
        utils.deleteDraft(self, self.call._timestamp, 'call').then(() => {
          const createdId = response?.data?._id
          if (createdId) {
            self.$router.replace('/chiamate/' + createdId)
          } else {
            self.$router.push('/chiamate')
          }
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    updateCall() {
      if (!this.checkRequired()) return

      const self = this
      this.disabledSave = true

      if (this.fastInsert) {
        this.normalizeTempClientProvinces()
        this.call.client = null
        this.call.occupant = null
        this.call.place = null
        this.call.implant = null
      } else {
        this.call.tempClient = {}
      }

      this.$http.put('/call/' + this.call._id, this.call)
      .then(function (response) {
        utils.deleteDraft(self, self.call._timestamp, 'call').then(() => {
          self.disabledSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    checkRequired() {
      if (!this.fastInsert && !this.call.lost && ((!this.call.client || !this.call.client._id) && (!this.call.occupant || !this.call.occupant._id))) {
        alert('Seleziona un proprietario o un occupante!')
        return false
      } else {
        return true
      }
    },

    getPlaces(compileImplant = true) {
      const self = this
      self.waitPlaces = true

      const client = this.call.client ? this.call.client._id : null
      const occupant = this.call.occupant ? this.call.occupant._id : null

      let query = ''
      if (client) {
        query = '/place/client-from-implant/' + client
      } else if (occupant) {
        query = '/place/occupant-from-implant/' + occupant
      }

      if (query) {
        this.$http.get(query)
        .then(function (response) {
          if (response && response.data) {
            self.places = response.data

            if (self.places.length === 1) {
              if (compileImplant) {
                self.call.place = self.places[0]
              }
              self.changePlace(self.call.place, compileImplant)
            }
          }
          self.waitPlaces = false
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
        })
      }
    },

    getImplants(place, compileImplant = true) {
      const self = this
      self.waitImplants = true

      this.$http.get('/implant', { params: {page: 1, size: -1, place_id: place._id} })
      .then(function (response) {
        if (response && response.data) {
          self.implants = response.data.records

          if (self.implants.length === 1 && compileImplant) {
            self.call.implant = self.implants[0]
            self.changeImplant(self.implants[0])
          }
        }
        self.waitImplants = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    changeClient(client) {
      if (client) {
        this.clearImplantSearch()
        this.call.occupant = null
        this.call.place = null
        this.call.implant = null

        this.disableOccupant = true

        this.getPlaces()
      } else {
        this.call.place = null
        this.call.implant = null

        this.disableOccupant = false
      }
    },

    changeOccupant(occupant) {
      if (occupant) {
        this.clearImplantSearch()
        this.call.client = null
        this.call.place = null
        this.call.implant = null

        this.disableClient = true

        this.getPlaces()
      } else {
        this.call.place = null
        this.call.implant = null

        this.disableClient = false
      }
    },

    changePlace(place, compileImplant = true) {
      const self = this

      if (compileImplant) {
        this.call.implant = null
      }

      if (place?._id) {
        this.getImplants(place, compileImplant)

        //controllo chiamate passate
        this.$http.get('/call/', { params: {
          place_id: place._id,
          startDate: utils.getBefore30Day(),
          endDate: utils.getAfter30Day()
        }})
        .then(function (response) {
          console.log(response)
          const records = response?.data?.records
          //rimuovi chiamata corrente
          const filteredRecords = records.filter(call => call._id !== self.call._id)
          if (filteredRecords?.length) {
            self.similarCalls = filteredRecords
          } else {
            self.similarCalls = []
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.disableClient = false
        this.disableOccupant = false
      }
    },

    selectImplantSearch(implant) {
      if (!implant) {
        return
      }

      this.call.client = implant.client || null
      this.call.occupant = implant.occupant || null
      this.call.place = implant.place_occupant || null
      this.call.implant = implant || null

      this.disableClient = false
      this.disableOccupant = false

      if (this.call.place) {
        this.changePlace(this.call.place, false)
      }

      if (this.call.implant) {
        this.changeImplant(this.call.implant)
      }
    },

    clearImplantSearch() {
      this.implantSearch = null
    },


    changeImplant(implant) {
      if (implant) {
        if (implant.client) {
          this.call.client = implant.client
        }
        if (implant.occupant) {
          this.call.occupant = implant.occupant
        }
      }
    },

    goBack() {
      this.$store.commit('setForm', {name: 'call', value: false})
      this.$router.back()
    },

    saveFastContact() {
      const self = this
      this.disabledFastContactSave = true

      const contacts = Object.assign([], this.call.client.contacts)
      contacts.push(this.newContact)

      this.$http.put('/client/' + this.call.client._id, {contacts})
      .then(function (response) {
        self.call.client.contacts = response.data.contacts

        self.newContact = {
          name: '',
          telephone: ''
        }

        self.openFastContact = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledFastContactSave = false
      })
    },

    calcBg(priority) {
      return utils.calcPriorityColor(priority)
    },

    searchTelephone() {
      const self = this

      this.searchingTelephone = true

      const telephone = this.call.lost_number

      this.$http.get('/client', { params: {
        size: 10,
        telephone
      } }).then(response => {
        self.clients = response.data.records
        self.openClientList = true

        self.searchingTelephone = false
      })
    },

    addClientFromSearch(client) {
      this.call.client = client
      this.changeClient(client)
      this.openClientList = false
    },

    addOccupantFromSearch(client) {
      this.call.occupant = client
      this.changeOccupant(client)
      this.openClientList = false
    }
  },

  watch: {
    call: {
      handler(value) {
        utils.prepareDraft(this, this.call, value, 'call')
      },
      deep: true
    }
  },

  mounted() {
    const self = this

    const id = this.$route.params.id

    if (id) {
      this.$http.get('/call/' + id)
      .then(function (response) {
        self.call = response.data

        if (
          self.call.tempClient.name || self.call.tempClient.surname || self.call.tempClient.business_name ||
          self.call.tempClient.name_owner || self.call.tempClient.surname_owner || self.call.tempClient.business_name_owner ||
          self.call.tempClient.installer
       ) {
          self.fastInsert = true

          if (self.call.tempClient.business_name) {
            self.init.name = self.call.tempClient.business_name
          } else {
            self.init.name = self.$fullname(self.call.tempClient)
          }

          self.init.subname = self.call.tempClient.city
        } else {
          if (self.call.client) {
            if (self.call.client.business_name) {
              self.init.name = self.call.client.business_name
            } else {
              self.init.name = self.$fullname(self.call.client)
            }
          }
          if (self.call.place) {
            self.init.subname = self.call.place.city
          }
        }

        self.getPlaces(false)

        self.waitRecord = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      self.waitRecord = false

      if (this.$store.getters.getForm('call')) {
        self.call = this.$store.getters.getForm('call')
      }
    }

    this.$http.get('/client/filter')
      .then(function (response) {
        if (response && response.data) {
          self.clients = response.data
        }
        self.waitClients = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })

    this.$http.get('/client/filter')
      .then(function (response) {
        if (response && response.data) {
          self.installers = response.data.filter(client => !!client.isInstaller)
        }
        self.waitInstallers = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })

  }
}
</script>